module.exports = __webpack_public_path__ + "img/stripe.4ac82837.png";